export enum TopUpWithdrawState {
  UnDef = -1,
  Topup = 0,
  Withdraw
}
